import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { browserHistory } from 'react-router';

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

interface IState {
	searchKeyword: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType15 extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			searchKeyword: '',
		};

		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
	}

	public componentDidMount() {}

	private handleSearchEnterPress(event: any) {
		if (!this.state.searchKeyword) {
			return;
		}
		if (event.key === 'Enter') {
			browserHistory.push(`/magazine/search/${this.state.searchKeyword}`);
		}
	}

	private handleSearchButtonClick() {
		if (!this.state.searchKeyword) {
			return;
		}
		browserHistory.push(`/magazine/search/${this.state.searchKeyword}`);
	}

	public render() {
		const { t } = this.props;

		return (
			<div className="container sectionType15-container">
				<div className="fieldHolder">
					<div className={c.ARTICLES_SEARCH_FILTER}>
						<div key="searchFilterFieldKey" className="inputHolder">
							<input
								type="text"
								name="searchArticles"
								onKeyPress={this.handleSearchEnterPress}
								onChange={(e) => this.setState({ searchKeyword: e.target.value })}
								placeholder={t('BSPortal_Common_Search') + '...'}
							/>
							<button onClick={this.handleSearchButtonClick}>
								<img src={require('containers/Html/icons/search1.svg')} className="icon" />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType15 };
